import React from 'react';
import Timestamp from 'react-chatbot/Timestamp';

/** Time with default formatting & locale */
const DefaultFormat = () => <Timestamp />;

export default DefaultFormat;


// WEBPACK FOOTER //
// ./src/docs/examples/Timestamp/DefaultFormatTimestamp.js